import { makeStyles } from "tss-react/mui";

export const useNWONSubServiceCardStyles = makeStyles<{
  hasDetailPage: boolean;
}>()((theme, { hasDetailPage }) => ({
  link: {
    textDecoration: "none",
  },
  aTag: {
    textDecoration: "none",
  },
  card: {
    cursor: hasDetailPage ? "pointer" : "inherit",
    transition: hasDetailPage ? "border-color 0.2s" : "none",
    ":hover": {
      borderColor: hasDetailPage ? theme.palette.grey[900] : "none",
    },
  },
  textWrapper: {
    paddingRight: theme.spacing(1),
  },
  title: {
    marginTop: theme.spacing(0.5),
  },
  arrowWrapper: {
    justifyContent: "flex-end",
  },
}));
